/// <amd-module name="typeahead/core/presentation/DropDownShowHandlersAssembly" />

import {DefaultPluginAssembly} from "typeahead/core/plugins/DefaultPluginAssembly";
import {IDropDownShowHandler} from "typeahead/core/presentation/IDropDownShowHandler";

export class DropDownShowHandlersAssembly {
   private handlers: Array< IDropDownShowHandler<any> >;

    public constructor(pluginAssembly: IPluginAssembly) {
        this.handlers = pluginAssembly.get(DefaultPluginAssembly.dropDownShowHandler);
    }

    public runHandlers($dropDownElement: JQuery, $inputElement: JQuery, context: IContext): void {
        this.handlers.map((plugin: IDropDownShowHandler<any>): JQueryPromise<any> => {
            return plugin.handleDropDownShow($dropDownElement, $inputElement, context);
        });
    }
}
